import React, { Component } from "react";
import PropTypes from "prop-types";
import RenderError from "../ui/RenderError";
import cn from "classnames";

export default class FormGroup extends Component {
  static propTypes = {
    locals: PropTypes.object.isRequired,
    className: PropTypes.string
  };

  state = {
    renderError: false
  };

  componentDidCatch(renderError) {
    this.setState({ renderError });
  }

  renderPart = className => {
    const { renderError } = this.state;
    const {
      locals: { label, attrs, help, error, hasError },
      children
    } = this.props;

    return (
      <div className={className}>
        {!!label && (
          <label className="control-label" htmlFor={attrs && attrs.id}>
            {label}
          </label>
        )}
        {renderError ? (
          <RenderError locals={this.props.locals} error={renderError} />
        ) : (
          children
        )}
        {!!help && <div className="help-block">{help}</div>}
        {hasError && <div className="error-block">{error}</div>}
      </div>
    );
  };

  renderPartDefinition = className => {
    const {
      locals: { label, attrs, help, error, hasError },
      children
    } = this.props;

    return (
      <div className={className}>
        {!!label && (
          <div className="field-label">
            <label className="control-label" htmlFor={attrs && attrs.id}>
              {label}
            </label>
            <div className="help-block">{help}</div>
          </div>
        )}
        <div className="field-item">{children}</div>
        {hasError && <div className="error-block">{error}</div>}
      </div>
    );
  };

  render() {
    const {
      locals: { config, hasError, required },
      children
    } = this.props;
    const type = config.type || "part";
    let fieldLayout = "";

    if (config.definition && config.definition.display === "hidden") {
      return <div className="hidden">{children}</div>;
    }

    const className = cn("form-group", config.className, {
      required: required || config.required,
      error: hasError
    });

    if (config.size && config.max) {
      const cols =
        Math.min(config.size, config.max) * Math.ceil(12 / config.max);
      fieldLayout = `field-layout-${cols}`;
    }

    return (
      <div className={cn(this.props.className, fieldLayout)}>
        {type === "partDefinition"
          ? this.renderPartDefinition(className)
          : this.renderPart(className)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/fields/FormGroup.js